<div class="contain" >
  <div *ngIf="esPersona; else institucion">
    <div class="space">
      <p class="color">Nombre:</p> 
      <p>{{persona_nombre_completo}}</p>
    </div>
    <div class="space">
    <p class="color">Documento:</p>
    <p>{{persona_documento_persona_numero}}</p>
    </div>
  </div>

  <ng-template #institucion>
    <div class="space">
      <p class="color">Denominación social:</p>
      <p>{{persona_jurica_denominacion_social}}</p>
    </div>
    <div class="space">
      <p class="color">Nombre fantasía:</p>
      <p>{{persona_juridica_nombre_fantasia}}</p>
    </div>
    <div class="space">
      <p class="color">RUT:</p>
      <p>{{persona_juridica_rut}}</p>
    </div>
  </ng-template>

  <div class="space">
  <p class="color">Rol:</p>
  <p>{{rol_tipo_rol_id_nombre}}</p>
  </div>

</div>
